module.exports = __webpack_public_path__ + "img/wxqrcode.4cffe759.png";